import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { receiveFilter, setLoading } from 'src/ducks/liveSession'
import { StyledTabContainer } from './styled'
import BackToHomeButton from 'src/components/BackToHomeButton'

export const SessionDateTab = () => {
  const dispatch = useDispatch()
  const { filterBy } = useSelector((state) => state.liveSession)

  const dateTabArray = [
    { type: 'date', tabText: 'Day 1', tabValue: '18 MAR' },
    { type: 'date', tabText: 'Day 2', tabValue: '19 MAR' },
  ]

  const onFilter = (kv) => {
    dispatch(setLoading(true))
    dispatch(receiveFilter(kv))
    setTimeout(() => {
      dispatch(setLoading(false))
    }, 300)
  }

  return (
    <StyledTabContainer>
      <div className="tab-container">
        {dateTabArray.map((date) => (
          <div
            key={date.tabValue}
            className={`tab-item ${filterBy['tabValue'] === date.tabValue ? 'selected' : ''} ${date.type === 'access' ? 'access' : 'date'}`}
            onClick={() => onFilter(date)}
          >
            <span className="mobile-hide">{date.tabText}</span>
            <span className="mobile-show">{date.tabValue}</span>
          </div>
        ))}
      </div>
      <div style={{ position: 'absolute', right: '0'}}>
        <BackToHomeButton />
      </div>
    </StyledTabContainer>
  )
}